import { GamesAnalytics } from "@/games/analytics/analytics-games";
import { onViewportEnter } from "@sazka/utils/viewport-enter";

const useGameNewsCarouselAnalytics = (carouselWrapper: HTMLElement) => {
    if (!carouselWrapper) return;

    const root = carouselWrapper.querySelector<HTMLElement>(".games-news");
    if (!root) return;

    const newsItems = carouselWrapper.querySelectorAll<HTMLElement>(".games-news-item");

    newsItems.forEach((item, index) => {
        onViewportEnter(item).then(() => {
            GamesAnalytics.pushArticleChange(index);
        });
    });
};

document.ready(() => {
    const carousels = document.querySelectorAll<HTMLDivElement>(".games-news__wrapper");

    carousels.forEach((root) => {
        useGameNewsCarouselAnalytics(root);
    });

    const allNewsBtn = document.querySelector("#all-news-btn");
    allNewsBtn?.addEventListener("click", () => GamesAnalytics.pushOfficeNewsClick());
});
